module.exports = __webpack_public_path__ + "static/img/discover2.48cbe57b.jpg";